// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Helper from "./Helper.bs.js";
import * as Pervasives from "rescript/lib/es6/pervasives.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";

function fromStringUnsafe(prim) {
  return prim;
}

function make(tokenId) {
  if (Helper.isPositiveStringInteger(tokenId)) {
    return Caml_option.some(tokenId);
  }
  
}

function makeWithDefault(tokenId, $$default) {
  var id = make(tokenId);
  if (id !== undefined) {
    return Caml_option.valFromOption(id);
  } else {
    return String(Math.abs($$default));
  }
}

function makeFromInt(tokenId) {
  return String(Math.abs(tokenId));
}

function toString(prim) {
  return prim;
}

var toInt = Pervasives.int_of_string_opt;

export {
  fromStringUnsafe ,
  make ,
  makeWithDefault ,
  makeFromInt ,
  toString ,
  toInt ,
  
}
/* Helper Not a pure module */
